import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.76 7v5.8a2 2 0 0 1-1.95 1.95H10.9a.76.76 0 0 1-.75-.75V9.12H5.86V14a.76.76 0 0 1-.75.75h-1.9a2 2 0 0 1-1.95-1.95V7a.74.74 0 0 1 .27-.57l6-5 .14-.09.15-.05h.45a.76.76 0 0 1 .19.12l6 5a.74.74 0 0 1 .3.59Z';
const draw24px =
  'M22.52,11.47a.72.72,0,0,1,.17.81.74.74,0,0,1-.69.47H20.75V20A2.75,2.75,0,0,1,18,22.75H15.37a.74.74,0,0,1-.75-.75V15.15H9.38V22a.75.75,0,0,1-.75.75H6A2.75,2.75,0,0,1,3.25,20V12.75H2a.75.75,0,0,1-.7-.47.76.76,0,0,1,.17-.81l10-9.78h0a.82.82,0,0,1,.25-.16.77.77,0,0,1,.56,0,.85.85,0,0,1,.25.17Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const HomeFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'homeFilled'),
) as IconWithRender;

HomeFilledIcon.displayName = 'HomeFilledIcon';
HomeFilledIcon.propTypes = Icon.propTypes;
HomeFilledIcon.renderIcon = (props) => <HomeFilledIcon {...props} />;
export default HomeFilledIcon;
